import {HttpClient} from "../../service/httpClient/HttpClient";
import moment from "jalali-moment";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {convertPersianDateToUniversalDate} from "../../utils/TimeConvertor";

export class InstallmentsService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    loadLoanInstallments(fundID, group, date, installmentsBType = false) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/groups/${group}/installments/from-date/${moment.from(date, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')}`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    "includes-monthly-deposit": installmentsBType
                }
            ).then(resolve).catch(reject)
        })
    }

    updateLoanInstallments(fundID, payedList, isTypeB = false) {
        this.loading(setLoadingStateDispatch(true))

        if (isTypeB) {
            this.httpClient.put(
                `fund-presentation/funds/${fundID}/installments/kinds/with-monthly-deposit/submit-paid`,
                this.httpClient.prepareUserAccessHeader(this.token),
                payedList
            ).then(response => {
                this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "پرداخت اقساط با موفقیت انجام شد."))
                this.loading(setLoadingStateDispatch(false))
            }).catch(reason => {
                ServerErrorHandler(reason, "خطا در پرداخت اقساط!", this.snackbar, this.loading)
            })
        } else {
            this.httpClient.put(
                `fund-presentation/funds/${fundID}/installments/kinds/normal/submit-paid`,
                this.httpClient.prepareUserAccessHeader(this.token),
                payedList
            ).then(response => {
                this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "پرداخت اقساط با موفقیت انجام شد."))
                this.loading(setLoadingStateDispatch(false))
            }).catch(reason => {
                ServerErrorHandler(reason, "خطا در پرداخت اقساط!", this.snackbar, this.loading)
            })
        }
    }

    getInstallmentsList(fundID, page, filters, paymentStatus, endDate = "", size = 20) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/installments`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page,
                    size,
                    "paid-status": paymentStatus,
                    "end-date": endDate && endDate.length === 10 ? convertPersianDateToUniversalDate(endDate) : "",
                    ...filters
                }
            ).then(resolve).catch(reject)
        })
    }
}